/* differ* — site rewire, 11 Sep 2026.

   Two jobs, both small:

   1. The sticky bar. Show it past 25% of the page, hide it whenever any
      waitlist form is on screen, and let a visible close control dismiss it
      for the session. Nothing here runs before the page is usable, and if
      this file fails to load the bar simply stays hidden.

   2. One receipt, not three. Shopify flags posted_successfully? on every
      customer form on the page, so all three placements would stamp a
      receipt at once. We remember which form was submitted and clear the
      others on the way back. */
(function () {
  'use strict';

  var SUBMITTED_KEY = 'differWaitlistSource';

  /* ---------------------------------------------------------------- 1 of 2
     Remember the form that was actually used, then keep only its receipt. */

  function rememberSource() {
    document.querySelectorAll('form[id$="Form"]').forEach(function (form) {
      var field = form.querySelector('input[name="contact[email]"]');
      if (!field) return;
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(SUBMITTED_KEY, form.id); } catch (e) { /* private mode */ }
      });
    });
  }

  function pruneReceipts() {
    var receipts = document.querySelectorAll('[data-differ-wl-confirm]');
    if (receipts.length < 2) return;

    var used = null;
    try { used = sessionStorage.getItem(SUBMITTED_KEY); } catch (e) { /* private mode */ }

    /* With nothing remembered, keep the first receipt in document order —
       the hero — because that is where the visitor lands after the redirect. */
    var keep = null;
    if (used) {
      receipts.forEach(function (node) {
        var form = node.closest('form');
        if (form && form.id === used) keep = node;
      });
    }
    if (!keep) keep = receipts[0];

    receipts.forEach(function (node) {
      if (node !== keep) node.hidden = true;
    });

    try { sessionStorage.removeItem(SUBMITTED_KEY); } catch (e) { /* private mode */ }
  }

  /* ---------------------------------------------------------------- 2 of 2
     The sticky bar. */

  function stickyBar() {
    var bar = document.querySelector('[data-differ-stickybar]');
    if (!bar) return;

    /* Someone carrying the founder flag has already told us they are in,
       either by signing up or by claiming their code on the gate. Asking
       again with a sticky bar is noise. */
    try {
      if (localStorage.getItem('differFounderIn') === '1') {
        bar.parentNode.removeChild(bar);
        return;
      }
    } catch (e) { /* private mode: fall through and show the bar */ }

    /* And never two invitations at once: while the gate is open the bar
       stays out of the way. The CSS hides it, this keeps it out of the
       tab order too. */
    if (document.querySelector('[data-differ-gate]:not([hidden])')) return;

    var root = document.documentElement;
    var closeBtn = bar.querySelector('[data-differ-stickybar-close]');
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('differStickyDismissed') === '1'; } catch (e) { /* private mode */ }
    if (dismissed) return;

    /* Every capture except the bar's own. The bar hides while any of them is
       on screen, so the visitor never sees two versions of the same field. */
    var forms = [].filter.call(
      document.querySelectorAll('.differ-wl, .differ-cta__form-wrap'),
      function (el) { return !bar.contains(el); }
    );

    /* A successful signup means there is nothing left to ask for. */
    if (document.querySelector('[data-differ-wl-confirm]')) return;

    bar.hidden = false;

    var formOnScreen = false;
    var ticking = false;

    function measure() {
      root.style.setProperty('--differ-stickybar-h', bar.offsetHeight + 'px');
    }

    function update() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var past = scrollable > 0 ? window.scrollY / scrollable > 0.25 : false;
      var show = past && !formOnScreen;
      bar.classList.toggle('is-active', show);
      root.classList.toggle('differ-stickybar-on', show);
      if (show) measure();
    }

    if ('IntersectionObserver' in window && forms.length) {
      var seen = new WeakSet();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) seen.add(entry.target); else seen.delete(entry.target);
        });
        formOnScreen = forms.some(function (f) { return seen.has(f); });
        update();
      }, { threshold: 0.15 });
      forms.forEach(function (f) { io.observe(f); });
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });

    window.addEventListener('resize', measure, { passive: true });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.remove('is-active');
        root.classList.remove('differ-stickybar-on');
        /* Wait out the slide-out before taking it out of the tab order. */
        window.setTimeout(function () { bar.hidden = true; }, 500);
        try { sessionStorage.setItem('differStickyDismissed', '1'); } catch (e) { /* private mode */ }
      });
    }

    measure();
    update();
  }

  function init() {
    rememberSource();
    pruneReceipts();
    stickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
